// extracted by mini-css-extract-plugin
export default {"main":"Qaa-z"};